(function() {
    'use strict';

    var directiveName = 'apTabToStr';
    
    angular.module('aprima-core-ui').directive(directiveName, ['_', '$parse', 'inputSelection', function (_, $parse, inputSelection) {
        var defaultKeyCode = 9; // tab key
        var defaultString = '_';

        // input:
        // string
        // '_'
        // OR
        // int code
        // 9
        // OR
        // [int code, string]
        // [9, '_']
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attrs, ngModel) {
                var _element = inputSelection.getChildElement(element);
                
                if(!_.hasIn(_element, 'selectionStart')) {
                    throw new Error('Can\'t use ' + directiveName + ' with ' + _element + ' because it doesn\'t' +
                        ' support \'selectionStart\'');
                }

                var keyCode = defaultKeyCode;
                var searchString = defaultString;

                var parsedConfig = $parse(attrs[directiveName]);

                if(parsedConfig.constant) {
                    processConfig(parsedConfig(scope));
                }
                else {
                    var configWatch = scope.$watch(parsedConfig, processConfig, parsedConfig.literal);
                }

                element.on('keydown', handleKey);

                scope.$on('$destroy', function(){
                    element.off('keydown', handleKey);
                    if(configWatch) {
                        configWatch();
                    }
                });

                function handleKey(e) {
                    var key = e.which || e.keyCode || 0;
                    if(key === keyCode) {
                        if(inputSelection.trySelectStr(_element, ngModel, searchString, _element.selectionEnd)) {
                            // if we can tab to the next string, then prevent the default action of tabbing to the
                            // next element
                            e.preventDefault();
                        }
                    }
                }

                function processConfig(config) {
                    if(config) {
                        if(_.isInteger(config)) {
                            keyCode = config;
                        }
                        else if(_.isInteger(config[0])) {
                            keyCode = config[0];
                            searchString = config[1];
                        }
                        else {
                            searchString = config;
                        }
                    }
                }
            }
        };
    }]);
})();
